import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'react-redux-spinner'
import BackTop from 'antd/lib/back-top'
import Layout from 'antd/lib/layout'
import LocaleProvider from 'antd/lib/locale-provider'

import Routes from 'routes'
import Content from './Content'
import Loader from './Loader'
import MenuLeft from './MenuLeft'
import Footer from './Footer'
import LayoutState from './LayoutState'

import { enquireScreen, unenquireScreen } from 'enquire-js'
import { ContainerQuery } from 'react-container-query'
import classNames from 'classnames'

import l8n from 'l8n'

const AntContent = Layout.Content
const AntFooter = Layout.Footer

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
}

let isMobile
enquireScreen(b => {
  isMobile = b
})

let contentBuffer = {
  pathName: null,
  content: null,
}

class MyLayout extends React.Component {
  static childContextTypes = {
    getContentBuffer: PropTypes.func,
    setContentBuffer: PropTypes.func,
  }

  state = {
    isMobile,
  }

  getChildContext() {
    return {
      getContentBuffer: () => contentBuffer,
      setContentBuffer: ({ pathName, content }) => (contentBuffer = { pathName, content }),
    }
  }

  componentDidMount() {
    this.enquireHandler = enquireScreen(mobile => {
      this.setState({
        isMobile: mobile,
      })
    })
    // Убираем из хранилища сообщение о новой версии партнерского кабинета
    window.localStorage.removeItem('new_version_message')
  }

  componentWillUnmount() {
    unenquireScreen(this.enquireHandler)
  }

  render() {
    const isMobile = !!this.state.isMobile
    const { user, logAsEnabled } = this.props
    return (
      <LocaleProvider locale={l8n.localeProvider}>
        <ContainerQuery query={query}>
          {params => (
            <div className={classNames(params)}>
              <LayoutState />
              <Layout>
                <Loader />
                <Spinner config={{ template: `<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div><div class="spinner-text">${l8n.p_loading}...</div></div>` }}/>
                <BackTop />
                <Routes />
                <MenuLeft 
                  user={user}
                  logAsEnabled={logAsEnabled}
                  isMobile={isMobile} 
                />
                <Layout>
                  <AntContent style={{ height: '100%' }}>
                    <Content />
                  </AntContent>
                  <AntFooter>
                    <Footer/>
                  </AntFooter>
                </Layout>
              </Layout>
            </div>
          )}
        </ContainerQuery>
      </LocaleProvider>
    )
  }
}

export default MyLayout



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Layout/index.js